import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let routers = []
const routerContext = require.context('./', true, /indexs\.js$/)
routerContext.keys().forEach(route => {
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  routers = [...routers, ...(routerModule.default || routerModule)]
})

export default new Router({
  mode: 'history',
  routes: routers
})
